import { FormControl, MenuItem, Select } from "@mui/material"
import { SELECT_BACKGROUND_COLOR } from "../../../constants/colors"
import { OrderStatusEnum } from "../../../enums/orderStatus"
import { useTranslation } from "react-i18next";

interface Props {
    value: OrderStatusEnum,
    onChange: (newValue: OrderStatusEnum) => void,
}

const SelectedOrderStatusComponents = ({ value, onChange }: Props) => {
    const { t } = useTranslation("global");

    return (
        <FormControl fullWidth sx={{ maxWidth: 250 }}>
            <Select
                id="shipment-method-id"
                value={value}
                size="small"
                onChange={(event: any) => {
                    onChange(event.target.value);
                }}
                sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
            >
                <MenuItem value={OrderStatusEnum.CURRENT_ORDER}>{t(OrderStatusEnum.CURRENT_ORDER)}</MenuItem>
                <MenuItem value={OrderStatusEnum.To_Pack} >{t(OrderStatusEnum.To_Pack)} </MenuItem>
                <MenuItem value={OrderStatusEnum.To_Ship} >{t(OrderStatusEnum.To_Ship)}</MenuItem>
                <MenuItem value={OrderStatusEnum.Rider_Getting_Order} >{t("order_page.Rider is getting")}</MenuItem>
                <MenuItem value={OrderStatusEnum.Shipping} >{t(OrderStatusEnum.Shipping)}</MenuItem>
                <MenuItem value={OrderStatusEnum.READY_TO_PICKUP} >{t("order_page.Ready to pick up")}</MenuItem>
            </Select>
        </FormControl>
    )
}
export default SelectedOrderStatusComponents